import React from 'react';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';
import { Reveal } from '../Reveal';
import { useLanguage } from '../../contexts/LanguageContext';
export function TaxSection() {
  const {
    t
  } = useLanguage();
  return <section className="bg-white py-24 sm:py-32" aria-labelledby="tax-heading" data-id="element-301" data-mp="2y143s2uhwcos">
      <div className="mx-auto max-w-shell px-5 sm:px-8" data-id="element-302" data-mp="32ymenys2p1zf">
        <div className="grid items-center gap-14 lg:grid-cols-2 lg:gap-20" data-id="element-303" data-mp="269esqpnjkquz">
          <Reveal data-id="element-304" data-mp="26b9bbxbcc6vw">
            <div data-id="element-305" data-mp="2ab00jwl7yeyb">
              <p className="text-[12px] font-semibold uppercase tracking-[0.2em] text-brand" data-id="element-306" data-mp="2aai7t9xrmiv5">
                {t.tax.eyebrow}
              </p>
              <h2 id="tax-heading" className="headline mt-5 text-[32px] font-bold text-ink sm:text-[44px]" data-id="element-307" data-mp="2f8js1y6xgo87">
                {t.tax.heading}
              </h2>
              <p className="mt-6 text-[17px] leading-relaxed text-ink/65" data-id="element-308" data-mp="1mlz1gzya0g5p">{t.tax.body}</p>

              <ul className="mt-9 grid gap-3 sm:grid-cols-2" data-id="element-309" data-mp="1rk8wnak03grb">
                {t.tax.items.map(item => <li key={item} className="flex items-center gap-3 rounded-2xl border border-ink/[0.07] bg-mist/70 px-4 py-3.5 transition-all duration-300 hover:-translate-y-0.5 hover:border-brand/25 hover:bg-white hover:shadow-soft" data-id="element-310" data-mp="101n3padx8x1n">
                    <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-brand/10" data-id="element-311" data-mp="r8b7wuodwmof">
                      <CheckIcon className="h-3 w-3 text-brand" aria-hidden="true" data-id="element-312" data-mp="m9qhfmyxphd6" />
                    </span>
                    <span className="text-[14px] font-medium text-ink/80" data-id="element-313" data-mp="hcgingpnntco">{item}</span>
                  </li>)}
              </ul>

              <a href="#consultation" className="group mt-9 inline-flex items-center gap-2 rounded-2xl border border-ink/12 bg-white px-7 py-4 text-[15px] font-semibold text-ink shadow-soft transition-all duration-300 hover:-translate-y-0.5 hover:border-ink/25" data-id="element-314" data-mp="8ah0um6tgl8o">
                {t.tax.cta}
                <ArrowRightIcon className="h-[18px] w-[18px] transition-transform duration-300 group-hover:translate-x-1" aria-hidden="true" data-id="element-315" data-mp="22m5i4v0iszw8" />
              </a>
            </div>
          </Reveal>

          <Reveal delay={0.1} data-id="element-316" data-mp="2gs766wfla73w">
            <div className="relative order-first lg:order-none" data-id="element-317" data-mp="2lla4fhvba4qf">
              <div className="overflow-hidden rounded-4xl border border-ink/[0.06] shadow-lift" data-id="element-318" data-mp="2lml6nd93z4ff">
                <img src="https://cdn.magicpatterns.com/patterns/generated-images/ad21188f-fb08-4d8c-898e-2799d55137e0.jpg" alt={t.tax.imageAlt} className="h-[320px] w-full object-cover sm:h-[460px]" data-id="element-319" data-mp="27rirs0maa4qh" />
              </div>
              <div className="absolute -bottom-6 left-4 w-[230px] rounded-3xl border border-white/50 bg-white/70 p-5 shadow-lift backdrop-blur-xl" data-id="element-320" data-mp="34jcmfcpfz1eq">
                <p className="text-[11px] font-semibold uppercase tracking-[0.16em] text-brand" data-id="element-321" data-mp="2qjbkdtxfxnxo">
                  {t.tax.badgeLabel}
                </p>
                <p className="mt-2 text-[26px] font-bold leading-none text-ink" data-id="element-322" data-mp="1f4y00z1wbqme">{t.tax.badgeValue}</p>
                <p className="mt-2 text-[13px] leading-snug text-ink/60" data-id="element-323" data-mp="1k4amvjsroxoz">{t.tax.badgeBody}</p>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>;
}